import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { Observable } from 'rxjs';
import { AppContext } from '../app.context';
import { NgMessage } from '../shared/ng-message';
import { HttpClientService } from './http-client.service';
import { HttpErrorHandler } from './http-error-handler';
import { NgResponse } from "../shared/ng-response";
import { FiscalYearReportingPeriodsResponse } from "../shared/fiscal-year.model";

class ReferenceDataNgResponse {
  messages: Array<NgMessage>;
  buildVersion: string;
}

@Injectable()
export class ReferenceDataService extends HttpClientService {
  constructor(readonly httpClient: HttpClient,
    readonly appContext: AppContext,
    readonly httpErrorHandler: HttpErrorHandler) {
    super('ReferenceDataService', httpClient, httpErrorHandler);
  }

  init(): Observable<any> {
    return new Observable(observer => {
      this.get<ReferenceDataNgResponse>(
        'messages',
          'api/ReferenceData/ReferenceData')
        .subscribe(ngResponse => {
          this.appContext.setReferenceData(
            ngResponse.response.messages,
            ngResponse.response.buildVersion);
          observer.next(this);
          observer.complete();
        });
    });
  }

  getAppInsightsKey(): Observable<any> {
    return new Observable(observer => {
      this.get<string>('AppInsightsKey', 'api/ReferenceData/AppInsightsKey')
        .subscribe(ngResponse => {
          this.appContext.appInsights = new ApplicationInsights({
            config: {
              instrumentationKey: ngResponse.response,
              enableAutoRouteTracking: true
            }
          });
          this.appContext.appInsights.loadAppInsights();
          observer.next(this);
          observer.complete();
        });
    });
  }

  getActiveFiscalYears(): Observable<NgResponse<FiscalYearReportingPeriodsResponse[]>> {
    return this.get<FiscalYearReportingPeriodsResponse[]>('getActiveFiscalYears', 'api/ReferenceData/ActiveFiscalYears');
  }
}
